module.exports = __webpack_public_path__ + "static/media/profile-1-hover.7159f215.png";